var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('m-headline',{attrs:{"description":_vm.$t('appointments.description'),"title":_vm.$t('appointments.title')}}),_c('m-appointments-list',{attrs:{"appointments":_vm.appointments}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }